import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d9cf786"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9cf786')) {
      api.createRecord('2d9cf786', component.options)
    } else {
      api.reload('2d9cf786', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d9cf786", function () {
      api.rerender('2d9cf786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/user_management/form/unbindWeChats/index.vue"
export default component.exports